export default "__VITE_ASSET__uPLLbLvh__"